export default class Deeplink implements IDigitalIdentityHubModule {
  public name = "Deeplink";

  public init(): void { /* No functionality */ }

  public ready(): void {
    const token = window.DigitalIdentityHub.utilities.getParameterByName("imtoken");
    if (token && window.DigitalIdentityHub.settings.enableFrontEndDeeplinking) {
      void window
        .fetch(`${window.DigitalIdentityHub.settings.deeplinkEndpoint}/profile?imtoken=${token}`)
        .then(r => r.json())
        .then(profile => {
          if (profile.uuid) {
            janrain.capture.ui.postCaptureForm("autoLoginForm", { token, uuid: profile.uuid });
          }
        });
    }
  }
}
